import { render, staticRenderFns } from "./fashionPanel.vue?vue&type=template&id=59df7264&"
import script from "./fashionPanel.vue?vue&type=script&lang=js&"
export * from "./fashionPanel.vue?vue&type=script&lang=js&"
import style0 from "./fashionPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports